import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import moment from "moment";

import { Input } from "components/Input";
import { Select } from "components/Select";
import { Checkbox } from "components/Checkbox";
import { Calendar } from "components/Calendar";
import { TimePicker } from "components/TimePicker";
import { RegularText } from "components/Text";

import DaysServices from "utils/days";

import { DOC_FIELD_TYPES } from "constant-data/documentsData";

import {
  openedDocumentStateAtom,
} from "atoms/documentsAtom";

import styles from "./styles.module.scss";

/**
 * Поля шапки документа (склад, дата, время, комментарий...)
 * по конфигу modalData из DocumentsData.
 */
export const DocumentHeaderFields = ({ elements, storesOptions }) => {
  const [state, setState] = useAtom(openedDocumentStateAtom);

  const patch = (update) => setState((prev) => ({ ...prev, ...update }));

  const [time, setTime] = useState("");
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    if (state.time) {
      setTime(moment(state.time).format("HH:mm:ss"));
      setDate(new Date(state.time));
    }
    // Инициализация из открытого документа один раз
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    patch({ time: DaysServices.setDateTime(date, time) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, time]);

  const storeVal =
    storesOptions.find((o) => String(o.value) === String(state.storeid ?? "")) ||
    null;
  const store2Val =
    storesOptions.find(
      (o) => String(o.value) === String(state.store2id ?? "")
    ) || null;

  return (
    <div className={styles.headerFields}>
      {elements.map(({ type, name, field }) => {
        switch (type) {
          case DOC_FIELD_TYPES.textPointer:
            return (
              <div className={styles.field} key={name}>
                <RegularText size={14}>
                  {String(name).replace(/:$/, "")}:
                </RegularText>
                <RegularText size={14} color="primary">
                  {state[field]}
                </RegularText>
              </div>
            );
          case DOC_FIELD_TYPES.store:
            return (
              <div className={styles.field} key={name}>
                <Select
                  label={name}
                  labelVariant="regular"
                  options={storesOptions}
                  value={storeVal}
                  onChange={(val) => patch({ storeid: val?.value })}
                  placeholder="Выберите склад"
                />
              </div>
            );
          case DOC_FIELD_TYPES.store2:
            return (
              <div className={styles.field} key={name}>
                <Select
                  label={name}
                  labelVariant="regular"
                  options={storesOptions}
                  value={store2Val}
                  onChange={(val) => patch({ store2id: val?.value })}
                  placeholder="Выберите склад"
                />
              </div>
            );
          case DOC_FIELD_TYPES.date:
            return (
              <div className={styles.field} key={name}>
                <Calendar
                  label="Дата"
                  labelVariant="regular"
                  value={date}
                  onChange={setDate}
                />
              </div>
            );
          case DOC_FIELD_TYPES.time:
            return (
              <div className={styles.field} key={name}>
                <TimePicker label={name} value={time} onChange={setTime} />
              </div>
            );
          case DOC_FIELD_TYPES.priceupdated:
            return (
              <div className={styles.field} key={name}>
                <Checkbox
                  label={name}
                  checked={!!state.priceupdated}
                  onChange={(checked) => patch({ priceupdated: checked })}
                />
              </div>
            );
          case DOC_FIELD_TYPES.comment:
            return (
              <div className={styles.field} key={name}>
                <Input
                  label={name}
                  labelVariant="regular"
                  value={state.comment ?? ""}
                  onChange={(ev) => patch({ comment: ev.target.value })}
                  inputWidth={420}
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
